import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client'
import { setContext } from "apollo-link-context";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { RuntimeHttpEndpointURL } from '@/js/multipleInstancesConfig';

const cache = new InMemoryCache();

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'token'
// Http endpoint
// let httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://127.0.0.1:8000/graphql'
// if (location.host == "affectations-qa.stereodev.ca") {
  //   httpEndpoint = 'https://affectqaapi.stereodev.ca/graphql'
  // }
  // if (location.host == "affectation-front.stereodev.ca") {
    //   httpEndpoint = 'https://affectation.stereodev.ca/graphql'
    // }
    
let httpEndpoint = RuntimeHttpEndpointURL() || 'http://127.0.0.1:8000/graphql'
Vue.prototype.$httpEndpoint = httpEndpoint;

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = window.localStorage.getItem(AUTH_TOKEN);
  // Return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      token: token || "",
    },
  };
});

// Config
const defaultOptions = {
  link: authLink,
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  wsEndpoint: null, //process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  // cache: myCache

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...

  // Additional ApolloClient options
  // apollo: { ... }

  // Client local data (see apollo-link-state)
  // clientState: { resolvers: { ... }, defaults: { ... } }
}

// Call this in the Vue app file

export const { apolloClient } = createApolloClient({
  ...defaultOptions,
  cache,
  resolvers: {},
  //...options,
});


export function createProvider () {
  //apolloClient.wsClient = wsClient

  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: "cache-and-network",
        fetchPolicy: "cache-first",
        // errorPolicy: 'all'
      },
    },
    async errorHandler(error) {
      // eslint-disable-next-line no-console
      // console.log(error.message)
      if (
        error.message == 'GraphQL error: Unauthenticated.'
        || error.message == 'GraphQL error: Password expired'
        || error.message == 'GraphQL error: Unauthorized access'
      ) {
        this.$q.notify({ type: 'negative', message: error.message });
        await this.$store.dispatch('auth/logout')
        this.$router.push({ name: 'login' })
      } else {
        console.log(
          "%cError",
          "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;",
          error.message
        );
      }
    },
  });

  return apolloProvider
}

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
  if (typeof localStorage !== 'undefined' && token) {
    localStorage.setItem(AUTH_TOKEN, token)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout (apolloClient) {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(AUTH_TOKEN)
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}
